export const globalMixin = {
  data() {
    return {
      STATUSES: {
        INACTIVE: 0,
        NEW: 0.5,
        ACTIVE: 1,
        CLOSEDOUT: 1,
        OPEN: 2,
        //applicable to Services
        CREATED: 0,
        INPROGRESS: 1,
        PAID: 2,
        CLOSED: 3,
        //Applicable to Orders
        INCART: 0,
        QUEUED: 1,
        PREPON: 2,
        READY: 3,
        INTRANSIT: 4,
        SERVED: 5,
        CLEARED: 6, // When cleaning over 
        PAIDINSERVICE: 7, //when service PAID
        CLOSEDINSECTION: 8, //when section closed
        CLOSEDINCOUNTER: 9, //when COUNTER CLOSED
        //--
        TOBEDELETED: -1
      }
    };
  },
  methods: {
    alert(msg) {
      alert("From globalMixin: " + msg)
    },
    getStatuses() {
      return this.STATUSES;
    },
    speak(text) {
      if ('speechSynthesis' in window) {
        var msg = new SpeechSynthesisUtterance();
        var voices = window.speechSynthesis.getVoices();
        msg.voice = voices[0];
        //msg.rate = $('#rate').val() / 10;
        //msg.pitch = $('#pitch').val();
        msg.text = text;
        msg.onend = function (e) {
          if (!e) alert('Finished in ' + event.elapsedTime + ' seconds.');
        };
        speechSynthesis.speak(msg);
      }
      else {
        alert('not supported')
      }
    },
    vibrate() {
      //TODO make it configurable globally
      navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
      navigator.vibrate && navigator.vibrate([75]);
    },
    print(txt) {
      if (navigator.bluetooth) {
        navigator.bluetooth.requestDevice({
          filters: [{
            services: ['000018f0-0000-1000-8000-00805f9b34fb']
          }]
        })
          .then(device => {
            // console.log('> Found ' + device.name);
            // console.log('Connecting to GATT Server...');
            return device.gatt.connect();
          })
          .then(server => server.getPrimaryService("000018f0-0000-1000-8000-00805f9b34fb"))
          .then(service => service.getCharacteristic("00002af1-0000-1000-8000-00805f9b34fb"))
          .then(characteristic => {
            let encoder = new TextEncoder("utf-8");
            // Add line feed + carriage return chars to text
            const lines = txt.split("\n");
            (async () => {
              for (let i = 0; i < lines.length; i++) {
                let text = encoder.encode(lines[i] + '\u000A\u000D');
                await characteristic.writeValue(text);
              }
              await characteristic.writeValue(encoder.encode('\u000A\u000D'));
              await characteristic.writeValue(encoder.encode('\u000A\u000D'));
            })();
          })
          .catch(error => {
            alert(`Error with web bluetooth: ${error.message}. Trying web share.`);
            if (navigator.share) {
              navigator
                .share({
                  title: "Tax Invoice",
                  text: txt,
                  url: window.url
                })
                .then(() => {
                  //console.log("Thanks for sharing!");
                })
                .catch(err => {
                  alert(`Error printing with web-share ${err.message}`);
                });
            } else {
              alert(`Can't print with both web-bluetooth and web-share.`);
            }
          });
      } else {
        if (navigator.share) {
          navigator
            .share({
              title: "Tax Invoice",
              text: txt,
              url: window.url
            })
            .then(() => {
              //console.log("Thanks for sharing!");
            })
            .catch(err => {
              alert(`Error printing with web-share. ${err.message}`);
            });
        } else {
          alert(`Can't print with both web-bluetooth and web-share.`);
        }
      }
    }
  }
}